import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@/utils/httpClient';

export interface AuditRecord {
  id: string;
  audit_timestamp: string;
  operation: 'INSERT' | 'UPDATE' | 'DELETE';
  entity_id: string | null;
  entity_type: string | null;
  entity_name: string | null;
  entity_identifier: string | null;
  user_id: string | null;
  user_name: string | null;
  user_email: string | null;
  change_summary: string;
  changed_fields: string[] | null;
  old_data: Record<string, unknown> | null;
  new_data: Record<string, unknown> | null;
}

interface UseEntityActivityOptions {
  entityId?: string;
  entityType?: string;
  limit?: number;
  enabled?: boolean;
  refetchInterval?: number;
}

export const useEntityActivity = ({
  entityId,
  entityType,
  limit = 10,
  enabled = true,
  refetchInterval = 5000,
}: UseEntityActivityOptions) => {
  return useQuery({
    queryKey: ['entity-activity', entityId, entityType, limit],
    queryFn: async (): Promise<AuditRecord[]> => {
      const params = new URLSearchParams();
      params.append('limit', limit.toString());
      params.append('order', 'audit_timestamp.desc');

      if (entityId) {
        params.append('entity_id', `eq.${entityId}`);
      }

      if (entityType) {
        params.append('entity_type', `eq.${entityType}`);
      }

      const endpoint = `/api/v1/entity_activity?${params.toString()}`;
      return httpClient.get<AuditRecord[]>(endpoint);
    },
    enabled: enabled && (!!entityId || !!entityType),
    refetchInterval,
  });
};
